document.addEventListener('DOMContentLoaded', function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  var duration = 5000; // ms per full revolution while hovering

  document.querySelectorAll('.circle-badge').forEach(function (badge) {
    var ring = badge.querySelector('.circle-badge__ring');
    if (!ring) return;

    var state = { angle: 0, rafId: null, rotating: false, startTime: null };

    function step(timestamp) {
      if (state.startTime === null) {
        state.startTime = timestamp - (state.angle / 360) * duration;
      }
      var elapsed = timestamp - state.startTime;
      state.angle = (elapsed / duration) * 360 % 360;
      ring.style.transition = 'none';
      ring.style.transform = 'rotate(' + state.angle + 'deg)';
      if (state.rotating) {
        state.rafId = requestAnimationFrame(step);
      }
    }

    function start() {
      if (state.rotating) return;
      state.rotating = true;
      state.startTime = null;
      cancelAnimationFrame(state.rafId);
      state.rafId = requestAnimationFrame(step);
    }

    function stop() {
      if (!state.rotating) return;
      state.rotating = false;
      cancelAnimationFrame(state.rafId);

      var remaining = 360 - state.angle;
      var target = state.angle + remaining;
      var glideDuration = (remaining / 360) * duration;

      ring.style.transition = 'transform ' + glideDuration + 'ms cubic-bezier(0.4, 0, 0.2, 1)';

      requestAnimationFrame(function () {
        ring.style.transform = 'rotate(' + target + 'deg)';
      });

      ring.addEventListener('transitionend', function handler() {
        ring.style.transition = 'none';
        ring.style.transform = 'rotate(0deg)';
        state.angle = 0;
        ring.removeEventListener('transitionend', handler);
      }, { once: true });
    }

    badge.addEventListener('mouseenter', start);
    badge.addEventListener('mouseleave', stop);
    badge.addEventListener('focus', start);
    badge.addEventListener('blur', stop);
  });
});